import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetGrammarWorkoutV2Response } from './get-grammar-workout-v2-response';
import { getGrammarWorkoutV2ResponseSchema } from './get-grammar-workout-v2-response';

export async function getGrammarWorkoutV2Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetGrammarWorkoutV2Response>> {
  return getRequest<IGetGrammarWorkoutV2Response>({
    path: '/grammar/workout/v2',
    schema: getGrammarWorkoutV2ResponseSchema,
    options,
  });
}
